import { InvisalignArticlePage } from "~/components/live-seo/pages/InvisalignArticlePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/why-patients-are-choosing-invisalign-in-miami-top-reasons",
)({
	head: async () =>
		(await import("~/utils/liveSeoHead")).headFromLiveSeo(
			"/why-patients-are-choosing-invisalign-in-miami-top-reasons",
		),
	component: InvisalignArticlePage,
});
